const TAGS:string[] = [
  "cpa",
  "cpc",
  "deeplink",
  "deal-site",
  "push",
  "pop",
  "premium-whitelist"
];

export default TAGS;